import { get } from '@rails/request.js'

// Shows a flash-style toast for a failure the client discovers on its own —
// one Turbo never round-trips through a server render for. Hits the same
// `GET /flash` endpoint a real `flash[:type] = text` would set
// (FlashController#show), which streams a `Ui::Flash::Component` toast into
// the page's existing tray, so a client-raised message looks identical to a
// server-set one.
export function showFlash (message, type = 'notice') {
  const params = new URLSearchParams({ type, text: message })
  get(`/flash?${params}`, { responseKind: 'turbo-stream' })
}
